import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/home/Index";
import DragonTendon from "./pages/services/DragonTendon";
import HotStone from "./pages/services/HotStone";
import MagneticFork from "./pages/services/MagneticFork";
import FasciaScraper from "./pages/services/FasciaScraper";
import PelvicFloor from "./pages/services/PelvicFloor";
import BlogPage from "./pages/blog/Index";
import ReviewsPage from "./pages/reviews/Index";
import AdminPage from "./pages/admin/Index";
import NotFound from "./pages/not-found/Index";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/services/dragon-tendon" element={<DragonTendon />} />
          <Route path="/services/hot-stone" element={<HotStone />} />
          <Route path="/services/magnetic-fork" element={<MagneticFork />} />
          <Route path="/services/fascia-scraper" element={<FasciaScraper />} />
          <Route path="/services/pelvic-floor" element={<PelvicFloor />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
